import { render, staticRenderFns } from "./BuyBackList.vue?vue&type=template&id=f058db22&scoped=true"
import script from "./BuyBackList.vue?vue&type=script&lang=js"
export * from "./BuyBackList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f058db22",
  null
  
)

/* custom blocks */
import block0 from "./BuyBackList.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports